var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiamondIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2.79768C0 1.25257 1.25257 0 2.79768 0H10.7023C12.2474 0 13.5 1.25257 13.5 2.79768V11.25C13.5 14.9779 10.4779 18 6.75 18C3.02208 18 0 14.9779 0 11.25V2.79768Z",
    fill: "#B5B5C4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.449219 2.91855C0.449219 1.61734 1.50406 0.5625 2.80527 0.5625H10.6932C11.9944 0.5625 13.0492 1.61734 13.0492 2.91855V11.25C13.0492 14.7294 10.2286 17.55 6.74922 17.55C3.26982 17.55 0.449219 14.7294 0.449219 11.25V2.91855Z",
    fill: "url(#paint0_linear_1048_23162)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.01172 4.9273C1.01172 4.00796 1.75699 3.2627 2.67633 3.2627H10.8221C11.7415 3.2627 12.4867 4.00797 12.4867 4.9273V11.2502C12.4867 14.4189 9.91795 16.9877 6.74922 16.9877C3.58048 16.9877 1.01172 14.4189 1.01172 11.2502V4.9273Z",
    fill: "url(#paint1_linear_1048_23162)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 13.7733L3.825 9.69922H4.93176L6.75 12.1019V13.7733Z",
    fill: "#CCCCCC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 5.62511L3.825 9.69922H4.93176L6.75 7.29654V5.62511Z",
    fill: "#F8F8F8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 13.7733L9.675 9.69922H8.56824L6.75 12.1019V13.7733Z",
    fill: "#9F9F9F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 5.62511L9.675 9.69922H8.56824L6.75 7.29654V5.62511Z",
    fill: "#CCCCCC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4.93164 9.69906L6.74988 7.29639L8.56813 9.69906L6.74988 12.1017L4.93164 9.69906Z",
    fill: "#E6E6E6"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1048_23162",
    x1: 0.701219,
    y1: 1.01229,
    x2: 3.9906,
    y2: 12.8932,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.463542,
    stopColor: "#A6A5B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898838,
    stopColor: "#D9D9DF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1048_23162",
    x1: 6.74922,
    y1: 3.2627,
    x2: 6.74922,
    y2: 16.9877,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A1A5C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#484157"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamondIcon);
export default __webpack_public_path__ + "static/media/diamondIcon.fa72173d82254211d92e71c7fbbee5ce.svg";
export { ForwardRef as ReactComponent };